<script lang="ts" setup>
	export type filterCollectionSchema = {
		key: string | number
		value: string | number
	}

	const { useDefaultClass = true, useUrl = false } = defineProps<{
		filterCollection: filterCollectionSchema[]
		filterBy?: string | number
		useDefaultClass?: boolean
		useCheckbox?: boolean
		useUrl?: boolean
	}>()
	const { urlQuery } = useUtils()
	const { replace } = useRouter()
	const filterQuery = computed(() => urlQuery.value?.filterBy ?? null)
	const emits = defineEmits<{
		(arg: 'update:filterBy', param: string): void
		(arg: 'change', param: string): void
	}>()
	const filter = (arg: string) => {
		if (arg) {
			emits('update:filterBy', arg)
			emits('change', arg)
			if (useUrl) {
				if (filterQuery.value !== arg) {
					replace({
						query: {
							...urlQuery.value,
							filterBy: arg
						}
					})
				}
			}
		}
	}
	onMount(() => filter(filterQuery.value))
</script>

<template>
	<a-dropdown trigger="click">
		<slot name="body">
			<div
				class="cursor-pointer border-gray-300"
				:class="[
					useDefaultClass
						? 'inline-block min-w-[104px] items-center justify-center gap-5 rounded-[28px] border p-[17px_24px]'
						: 'rounded-[inherit]'
				]"
			>
				<div class="flex w-full items-center justify-between gap-x-3">
					<span class="capitalize">
						<slot name="active-text" :filter-text="filterBy">
							{{ filterBy }}
						</slot>
					</span>

					<lazy-tools-icon
						icon="caret-down"
						dir="arrows"
						:width="10.61"
						:height="6.48"
						path-class="stroke-gray-700"
						class="inline"
					/>
				</div>
			</div>
		</slot>

		<template #overlay>
			<a-menu class="light-shadow min-w-[160px] !rounded-lg py-0">
				<a-menu-item
					v-for="(item, index) in filterCollection"
					:key="index"
					class="border-b border-gray-200 py-4 first:rounded-t-lg last:rounded-b-lg"
					:class="{
						'bg-gray-100 font-medium': item.key === filterBy
					}"
					@click="() => filter(item.key as string)"
				>
					<div class="flex cursor-pointer items-center">
						<a-checkbox v-if="useCheckbox" :checked="item.key === filterBy" class="pr-2" />
						<p class="capitalize">
							{{ item.value }}
						</p>
					</div>
				</a-menu-item>
			</a-menu>
		</template>
	</a-dropdown>
</template>
